import { useEffect, useState } from "react";
import { MapPin, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { ComparisonView } from "@/components/ComparisonView";

const MARK = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='360' height='240'><text x='40' y='150' transform='rotate(-25 180 120)' font-family='Arial' font-weight='700' font-size='56' fill='white' fill-opacity='0.06'>SAMPLE</text></svg>\")";

export const SampleComparison = () => {
  const [c, setC] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/public/sample-comparison").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return null;
  return (
    <section id="sample" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="sample-comparison">
      <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-semibold mb-3">See what you get</p>
      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-2">Sample franchise comparison</h2>
      <p className="flex items-center gap-1 text-sm text-slate-400 mb-8"><MapPin className="h-4 w-4 text-cyan-300" />{c.name} · {c.address}</p>
      <div className={`relative rounded-2xl border border-slate-800 bg-slate-900/40 p-6 overflow-hidden ${open ? "" : "max-h-[900px]"}`}>
        <span className="absolute top-4 right-4 z-20 rounded-full bg-amber-400 px-3 py-1 text-xs font-bold tracking-wider text-amber-950" data-testid="sample-badge">SAMPLE</span>
        <ComparisonView c={c} />
        <div className="pointer-events-none absolute inset-0 z-10" style={{ backgroundImage: MARK }} aria-hidden="true" />
        {!open && <div className="absolute inset-x-0 bottom-0 z-20 h-48 bg-gradient-to-t from-[#090d16] to-transparent flex items-end justify-center pb-6">
          <Button data-testid="sample-expand" onClick={() => setOpen(true)} className="rounded-full bg-slate-100 text-slate-900 hover:bg-white"><ChevronDown className="h-4 w-4 mr-1" />Show the full sample</Button>
        </div>}
      </div>
    </section>
  );
};
